import firebase from 'firebase'

export default {
  debug: 'warn',
  modules: {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],

        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }], // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
        [{ 'direction': 'rtl' }], // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],

        ['hr', 'hr-advance'],

        ['image', 'image2', 'link', 'ortography', 'ortography90']
      ],
      handlers: {
        // avoid alert dialog in block/embed
        'hr': function (value) {
          this.quill.format('hr', true)
        },
        'hr-advance': function (value) {
          this.quill.format('hr-advance', true)
        },
        // 'ortography': function () {
        //   console.log('ortography')
        // }
        'image2': function () {
          console.log('image2')
          const input = document.createElement('input')
          input.setAttribute('type', 'file')
          input.click()
          // Listen upload local image and save to server
          input.onchange = () => {
            const file = input.files[0]
            const UUID = require('uuid-v4')
            let uuid = UUID()
            // file type is only image.
            if (/^image\//.test(file.type)) {
              // saveToServer(file);
              const storageRef = firebase.storage().ref().child('book-images/' + uuid + '.' + file.type.replace(/.*\//, ''))
              storageRef.put(file).then(() => {
                // Get URL and store to pass
                storageRef.getDownloadURL().then((result) => {
                  console.log(result + '&fool_type=.jpg') // adding .jpg to fool epub generator!
                  const range = this.quill.getSelection()
                  this.quill.insertEmbed(range.index, 'image', result + '&fool_type=.jpg')
                })
              })
            } else {
              console.warn('You could only upload images.')
            }
          }
        }
      }
    }
  },
  placeholder: '',
  theme: 'snow' /* bubble snow */
}



// WEBPACK FOOTER //
// ./src/components/Admin/content/editor-options-complete.js